import * as React from "react";
import * as RD from "@radix-ui/react-dropdown-menu";

import { cn } from "~/lib/utils";
import { SDContentProps, SDLabelProps, SDRootProps, SDRootRef } from "./types";

const Root = React.forwardRef<SDRootRef, SDRootProps>(
  function Root(props, ref) {
    const isControlled = props.open !== undefined;
    const [innerOpen, setInnerOpen] = React.useState(false);
    const open = isControlled ? props.open : innerOpen;
    React.useImperativeHandle(
      ref,
      () => ({
        present: () => setInnerOpen(true),
        dismiss: () => setInnerOpen(false),
      }),
      [],
    );
    return (
      <RD.DropdownMenu
        {...props}
        open={open}
        onOpenChange={isControlled ? props.onOpenChange : setInnerOpen}
      />
    );
  },
);

const Trigger = RD.DropdownMenuTrigger;

const Content = React.forwardRef<HTMLDivElement, SDContentProps>(
  function Content(props, ref) {
    const { className, ...rest } = props;
    return (
      <RD.Portal>
        <RD.Content
          {...rest}
          className={cn(
            "border-input-border bg-surface-secondary rounded-lg border p-2 shadow-lg",
            className,
          )}
          ref={ref}
        />
      </RD.Portal>
    );
  },
);

const Label = React.forwardRef<HTMLDivElement, SDLabelProps>((props, ref) => (
  <RD.DropdownMenuLabel
    {...props}
    className={cn(
      "text-text-secondary px-2 text-sm uppercase",
      props.className,
    )}
    ref={ref}
  />
));
const Group = RD.DropdownMenuGroup;
const Separator = RD.DropdownMenuSeparator;
const Item = RD.DropdownMenuItem;
const CheckboxItem = RD.DropdownMenuCheckboxItem;
const RadioGroup = RD.DropdownMenuRadioGroup;
const RadioItem = RD.DropdownMenuRadioItem;
const ItemIndicator = RD.DropdownMenuItemIndicator;

export {
  Root,
  Trigger,
  Content,
  Label,
  Group,
  Separator,
  Item,
  CheckboxItem,
  RadioGroup,
  RadioItem,
  ItemIndicator,
};
